<div class="pb-4 mb-4 border-b">
	<ui-content-header type="section" title="Sync by Closer Settings">
		<ui-button actions (click)="close()" icon="x" preset="ICON_DEFAULT" />
	</ui-content-header>
</div>

<ng-container *ngIf="currentUserId === (getLoggedInBusinessUser$ | async)?.id">
	<app-closer-sync-general-settings
		section-content
		[currentUserId]="currentUserId"
	></app-closer-sync-general-settings>
</ng-container>
